import { apiV3RegItemReservationsPath } from 'lib/urls'
import { useQuery } from '@tanstack/react-query'
import { Reservation } from 'src/types/reservation'
import fetch from 'lib/fetch'

export const fetchReservationsForRegItem = (
  regItemId: number
): Promise<Reservation[]> => fetch(apiV3RegItemReservationsPath(regItemId))

const RESERVATIONS_QUERY_KEY = 'reservations'

export const useRegItemReservations = (regItemId: number) =>
  useQuery({
    enabled: !!regItemId,
    queryFn: () => fetchReservationsForRegItem(regItemId),
    queryKey: [RESERVATIONS_QUERY_KEY, regItemId],
  })
